module.exports = __webpack_public_path__ + "img/Card_club_3.8922d9d7.svg";